<script>
  import { TOKENS_PARTNERS } from '@/constants'

  export default {
    name: 'URLRedirect',
    async mounted() {
      console.log(window.location.pathname)
      if (window.location.pathname === '/pineapples') {
        sessionStorage.setItem('partner_name', TOKENS_PARTNERS.PINAPPLES.name)
        window.location.replace(`/qr/${TOKENS_PARTNERS.PINAPPLES.token}`)
      }
    },
    template: '<div></div>'
  }
</script>
